export class Sponsorship {
	campaignCat = [ 'Internal', 'Sub Discount Outlets', 'Long Term', 'Short Term' ];
  campaignIds = [ 'internal', 'sdo', 'long-term', 'short-term' ];
  campaignColours = ['hsl(320, 42%, 62.7%)', 'hsl(235, 42%, 62.7%)', 'hsl(152, 42%, 62.7%)', 'hsl(207, 42%, 62.7%)'];
  // campaignColours = ['#d5a6bd', '#a4c2f4', '#b6d7a8', '#ffd966'];
  campaignTypes = [ 'Spot', 'Live Read', 'Giveaway'];
}
